export class NegocioOportunidadeCreate {
    id: number;
    idFunilVenda: number;
    idCliente: number;
    idUsuarioResponsavel: number;
    prioridade: number;
    dataPrevisaoFechamento: Date;
    valor: number;
    idCampanha: number;
}
